import { FC } from 'react';
import Spinner from '../loading/spinner';
import { ButtonTheme } from './button-theme';
import { getDisabledThemeClasses, getThemeClasses } from './button-functions';

const Button: FC<{
  theme: ButtonTheme;
  identifier: string;
  classOverrides?: string;
  isLoading?: boolean;
  isDisabled?: boolean;
  type?: 'button' | 'submit';
  children: JSX.Element | JSX.Element[];
  onClick: () => any;
}> = ({
  theme,
  identifier,
  classOverrides,
  isLoading,
  isDisabled,
  type,
  children,
  onClick
}: {
  theme: ButtonTheme;
  identifier: string;
  classOverrides?: string;
  isLoading?: boolean;
  isDisabled?: boolean;
  type?: 'button' | 'submit';
  children: JSX.Element | JSX.Element[];
  onClick: () => any;
}) => {
  const classes = classOverrides ?? 'px-4 py-2.5';
  const themeClasses = isDisabled
    ? getDisabledThemeClasses(theme)
    : getThemeClasses(theme);

  return (
    <>
      <button
        onClick={isDisabled ? undefined : onClick}
        className={`relative transition-all text-sm rounded text-center ${themeClasses} ${classes}`}
        id={identifier}
        disabled={isDisabled}
        type={type ?? 'button'}
      >
        <div
          className={`absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 ${
            isLoading ? 'visible' : 'invisible'
          }`}
        >
          <Spinner></Spinner>
        </div>
        <span className={`${isLoading ? 'invisible' : 'visible'}`}>
          {children}
        </span>
      </button>
    </>
  );
};

export default Button;
